<template>
	<div>
		<div v-if="isActiveClient" class="activeClient">
			<div class="grid-container">
				<header class="header">
				<!-- <b-button-toolbar aria-label="Toolbar with button groups and dropdown menu">
					<b-input-group size="sm">
					<b-form-input :placeholder="$t('search')" class="text-left"></b-form-input>
					</b-input-group>
					<b-button-group size="sm" class="mr-1">
					<b-button><font-awesome-icon class="icon" icon="search" /></b-button>
					</b-button-group>
				</b-button-toolbar> -->
				</header>

				<main class="main">
					<div class="main_overview" v-if="subscription">
						<!-- <div class="overview_card bg-blue">
							<div
								class="overview_card-info"
								v-if="
								!isNaN(
									(subscription.units_created * 100) / subscription.unit_count
								)
								"
							>
								<vue-ellipse-progress
								:progress="
									parseFloat(
									(subscription.units_created * 100)
									)
								"
								:legendValue="subscription.units_created"
								color="var(--primaryDark)"
								:thickness="8"
								:loading="loading"
								:size="100"
								>
								<span data-qa="planUnitNoValue" class="circleNo" slot="legend-value"></span>
								<p class="circleTitle" slot="legend-caption">
									{{ $t('openUnits') }}
								</p>
								</vue-ellipse-progress>
							</div>
							<div
								class="overview_card-info"
								v-if="
								!isNaN(
									(subscription.storage_used * 100) /
									subscription.storage_value
								)
								"
							>
								<vue-ellipse-progress
								:progress="
									parseFloat(
									(subscription.storage_used * 100) /
										subscription.storage_value
									)
								"
								:legendValue="subscription.storage_used"
								color="var(--primaryDark)"
								:thickness="8"
								:size="100"
								>
									<span data-qa="planStorageValue" class="circleNo" slot="legend-value"
										>/{{ subscription.storage_value }}</span
									>
									<p class="circleTitle" slot="legend-caption">
										{{ subscription.storage_unit }} {{ $tc('storageUsage', 2) }}
									</p>
								</vue-ellipse-progress>
							</div>
						</div> -->
						<!--subscription details -->		
						<div class="overview_card bg-blue">
							<div class="overview_card-info">
								<!-- <p data-qa="subscriptionPlanLabel">
								{{ $t('subscriptionPlan') }}:
								<span data-qa="subscriptionPlanValue" style="text-transform: capitalize;">{{
									subscription.subscription_plan
								}}</span>
								</p> -->
								<p data-qa="selectedCurrencyLabel">
									{{ $t('selectedCurrency') }}:
									<strong><span data-qa="selectedCurrencyValue">{{ currencyConverter[subscription.currency] }}</span></strong>
								</p>
								<p v-if="subscription.amount && nextPaymentDate">
									{{ $t('nextPayment') }}: 
									<strong><span data-qa="nextPaymentDate">{{ nextPaymentDate }}</span></strong>
								</p>
								<p data-qa="subscriptionStatusLabel">
									{{ $t('status') }}:
									<strong><span data-qa="subscriptionStatusValue">{{subscriptionStatus | statusLang($i18n.locale)}}</span></strong>
								</p>
								<p v-if="subscription.status === 'canceled'">
									{{ $t('subscriptionPeriod') }}:
									<strong><span data-qa="subscriptionPeriod">{{subscriptionPeriod}}</span></strong>
								</p>
								<br />
								<!--ACTIVE account flow-->
								<!-- <a
								class="edit-btn"
								v-if="subscription.status === 'active'"
								@click="$bvModal.show('subscription-change')"
								data-qa="changePlanDashboardButton"
								>{{ $t('changePlan') }}</a
								> -->
								<!--ACTIVE account flow END-->
								<!-- <a
								class="edit-btn"
								v-if="Object.keys(subscription).length === 0 || subscription.status === 'inactive' || subscription.status === 'trial'"
								@click="$bvModal.show('subscription-modal')"
								data-qa="choosePlanDashboardButton"
								>{{ $t('subscribe') }}</a
								> -->
								<br />
								<div class="trial-end"
									v-if="
									subscription.failure_reason &&
									subscription.failure_reason !== null &&
									subscription.failure_reason !== 'void_invoice'
									"
								>
								{{ subscription.failure_reason }} {{ $t('paymentFailed') }}
								</div>
								<!-- <p style="font-size:0.8em">*{{ $t('VATdisclaimer') }}</p> -->
							</div>
						</div>

			<!--IF CLIENT EXCEED 50 EUR SALES WITHIN ONE MONTH IN ONE OF THE UNITS -->
						<div class="overview_card2 bg-alert" v-if="subscription.status === 'trial' && subscription.activeUnit > 0">
							<div>
								<strong>{{ $t('freemiumAlert1') }}</strong>
								<p style="text-align: left;">{{ $t('freemiumAlert2') }}</p>
							</div>
							<a
							class="add-card-btn"
							@click="openCreditCardForm('addition')"
							>{{ $t('addPaymentCard') }}</a>
						</div>

						<div class="overview_card bg-blue" v-else-if="subscription.status === 'validation pending'">
							<p>{{ $t('verifyCard') }}</p>
						</div>

						<div class="overview_card bg-alert" v-else-if="subscription.status === 'active'">
							<p style="text-align: left;">
							<span>{{ $t('freemiumAlert4') }}{{subscription.invoice.created | dateConversion}} {{ $t('for') }} {{subscription.invoice.amount_paid / 100}} EUR</span>
							</p>
							<a
							class="add-card-btn"
							@click="openCreditCardForm('updation')"
							>{{ $t('changeCardDetails') }}</a>
						</div>

						<div class="overview_card bg-blue" v-else>
							<!--top 3 selling products-->
							<!--1.PRODUCT-->
							<!--2.PRODUCT-->
							<!--3.PRODUCT-->
						</div>

						<div class="overview_card bg-blue">
							<!--top 3 selling units-->
							<!--1.UNIT-->
							<!--2.UNIT-->
							<!--3.UNIT-->
						</div>

						<div class="overview_card borderStyle">
							<!--data storage counter -->
							<div
								class="overview_card-info"
								v-if="
								!isNaN(
									(subscription.storage_used * 100) /
									subscription.storage_value
								)
								"
							>
								<Knob 
									v-model="value" 
									valueColor="var(--primaryDark)"
									valueTemplate="{value}MB" 
									rangeColor="var(--bg-ultraLight)"
									:size="120"
									readonly  />
								<small class="p-error" id="text-error">{{ errorMessage || '&nbsp;' }}</small>
							</div>
							<!--unit counter -->	
							<div
								class="overview_card-info iCountUp"
								v-if="
								!isNaN(
									(subscription.units_created * 100) / subscription.unit_count
								)
								"
							>
							<ICountUp
								:delay="delay"
								:endVal="endVal"
								:options="options"
								@ready="onReady"
								/>
							</div>
							<div style="text-align: left; color:var(--primaryDark);">{{ $t('openUnits') }}</div>
						</div>
					</div>

					<div class="main_cards">
						<div class="card">
							<h2 class="graphTitle">{{ $t('unitSalesTitle') }}</h2>
							<!-- <p>{{ $t('inDev') }}</p> -->
							<UnitSalesChartClient/>
						</div>

						<div class="card metricsContainer bgAlert">
							<div class="metricsName">
								<!-- <VueJsCounter class="metricsNo" start="1" end="4" decimal="."></VueJsCounter> -->
								<h1>CSAT</h1>
								<div class="help-tip">
									<p>{{ $t('CSATdesc') }}</p>
								</div>
								<p>{{ $t('inDev') }}</p>
							</div>
							<div class="metricsGraph">
								<!-- <CsatChartClient/> -->
							</div>
						</div>

						<div class="card metricsContainer bgAlert">
							<div class="metricsName">
								<!-- <VueJsCounter class="metricsNo" start="1" end="51"></VueJsCounter> -->
								<span class="metricsUnit">%</span>
								<h1>CAR</h1>
								<div class="help-tip">
									<p>{{ $t('CARdesc') }}</p>
								</div>
								<p>{{ $t('inDev') }}</p>
							</div>
							<div class="metricsGraph">
								<!-- <CarChartClient/> -->
							</div>
						</div>

						<div class="card metricsContainer bgAlert">
							<div class="metricsName">
								<!-- <VueJsCounter class="metricsNo" end="80"></VueJsCounter> -->
								<h1>NPS</h1>
								<div class="help-tip">
									<p>{{ $t('NPSdesc') }}</p>
								</div>
								<p>{{ $t('inDev') }}</p>
							</div>
							<div class="metricsGraph">
								<!-- <NpsChartClient/> -->
							</div>
						</div>

						<div class="card bgLightGray">
							<h3>{{ $t('CommentsGuest') }}</h3>
							<!-- COMMENTS FROM SERVICE_REVIEW MODAL shows here -->
						</div>

						<div class="card metricsContainer2 bg-gray">
							<div style="color: #ffffff">{{ $t('dashboardFeedback') }}</div>
							<div class="metricsName2">
								<b-button
								class="edit-btn2"
								@click="$bvModal.show('clientFeedback')"
								>{{ $t('sendFeedback1') }}
								</b-button>
								<b-modal
								id="clientFeedback"
								size="sm"
								body-class="hide-padding"
								no-stacking
								hide-footer
								content-class="clientFeedbackModal">
									<div>
										<p class="feedback">{{ $t('addOns1') }}</p>
										<br/>
										<p class="feedback">{{ $t('addOns2') }}</p>
										<p class="feedback">{{ $t('addOns3') }}</p>
										<p class="feedback">{{ $t('addOns4') }}</p>
										<br />
										<!-- <b-button
										class="login-btn mr20"
										@click="$bvModal.hide('clientFeedback')"
										>{{ $t('dismiss') }}</b-button
										> -->
										<b-button
										class="login-btn"
										href="mailto:accounts@expar-store.com"
										>{{ $t('sendFeedback1') }}
										</b-button>
									</div>
								</b-modal>
							</div>
						</div>
					</div>
				</main>
				<footer class="footer">
					<div class="footer_copyright">
						&copy;{{ new Date().getFullYear() }}
					</div>
					<div class="footer_byline">
						<img
						class="mb-2"
						src="../../src/assets/static/icons/expar_logo_new.svg"
						alt="logo"
						width="24"
						height="24"
						/>
						<span class="logo">expar&#8482;</span>
					</div>
				</footer>
			</div>
		</div>
		<!-- SHOWS ONLY WHERE CLIENT DID NOT CREATE ANY UNITPRODUCT YET -->
		<div v-else class="unitProductsEmpty">
			<CustomOrMarketplaceCards />
		</div>
		<!-- END OF INSTRUCTIONS -->
		<b-modal id="addCreditCard-modal" size="lg" hide-footer>
			<template v-slot:modal-title>
				<!-- {{ $t('changePlan') }} -->
			</template>
			<CreditCardForm
				:action="creditCardAction"
				:subscription="subscription"
				@subscribe-success="closeCreditCardModal"
			></CreditCardForm>
		</b-modal>
		<sweet-modal icon="success" ref="modalSuccess" name="successModal">
			{{ $t('confirmedSubscription') }}
			<br/>
		</sweet-modal>
		<sweet-modal icon="success" ref="modalCardSuccess" name="cardSuccessModal">
			{{ $t('creditCardChangeSuccess') }}
			<br/>
		</sweet-modal>
	</div>
</template>

<script>
import CustomOrMarketplaceCards from '@/components/onboarding/CustomOrMarketplaceCards.vue'
import moment from 'moment'
import Knob from 'primevue/knob'
import ICountUp from 'vue-countup-v2';
import CountUp from 'countup.js'

// import VueJsCounter from 'vue-js-counter'
// import SubscriptionTable from '@/components/ui/SubscriptionTable.vue'
import CreditCardForm from '@/components/forms/CreditCardForm.vue'
import dateFormat from 'dateformat'
import UnitSalesChartClient from '@/components/charts/UnitSalesChartClient.vue';

// import CsatChartClient from '@/components/charts/CsatChartClient.vue'
// import CarChartClient from '@/components/charts/CarChartClient.vue'
// import NpsChartClient from '@/components/charts/NpsChartClient.vue'

// import DeliveryOrdersTable from '@/components/ui/DeliveryOrdersTable.vue';

const subStatusMapping = {
  trial: 'poskusno obdobje',
  active: 'aktivno',
  inactive: 'neaktivno',
  'validation pending': 'potrebno validirati kartico'
}


export default {
  metaInfo() {
    return {
      title: this.$i18n.t('dashboard')
    }
  },
  components: {
    CustomOrMarketplaceCards,
	Knob,
	ICountUp,
    // SubscriptionTable,
	CreditCardForm,
    // VueJsCounter
    UnitSalesChartClient
    // CsatChartClient,
    // CarChartClient,
    // NpsChartClient
    // DeliveryOrdersTable
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    dateConversion: function(value) {
      return moment(String(new Date(value * 1000))).format('DD-MM-YYYY')
    },
    statusLang: function(value, lang) {
      return (value && lang.toLowerCase() === 'sl') ? subStatusMapping[value.toLowerCase()] : value
    }
  },
  computed: {
    subscription() {
      return this.$store.state.subscription.subscription
    },
    nextPaymentDate() {
      return this.subscription.status == this.$i18n.t('trial')
        ? moment(this.subscription.free_trial_end_date).format('DD/MM/YYYY')
        : this.subscription.status == 'active'
        ? moment(this.subscription.current_period_end).format('DD/MM/YYYY')
        : null
    }
  },
  async mounted() {
    this.$root.$on('updateSubscriptionDetails', async () => {
      this.updateSubscriptionDataOnScreen()
    })
    const clientDetails = await this.$store.dispatch(
      'client/fetchClientActiveDetail'
    )
    this.isActiveClient = clientDetails.client_active_flag
    this.updateSubscriptionDataOnScreen()
	const options = {
    // options for countUp.js, such as decimal places, separator, etc.
	};
	const countUp = new CountUp('target', 1000, options);
	countUp.start();
  },
  data() {
    return {
      unitsOpened: 3,
      unitCount: 6,
      unitsOpenedProcent: 50,
      storageUsed: 20,
      maxDataStorage: 50,
      storageUsedProcent: 40,
      subscriptionPlan: 'monthly',
      subscriptionStatus: 'trial',
      totalPrice: 35,
      selectedCurrency: '€',
      currencyConverter: {
        eur: '€',
        inr: '₹'
      },
      changePlan: true,
      isActiveClient: false,
      subscriptionPeriod: '',
      creditCardAction: null,
	  value: 20,
	  delay: 1000,
	  endVal: 3,
	  options: {
			useEasing: true,
			useGrouping: true,
			separator: ',',
			decimal: '.',
			prefix: '',
			suffix: ''
		}
    }
  },
  methods: {
    async closeModal() {
      this.$bvModal.hide('subscription-change')
      this.updateSubscriptionDataOnScreen()
    },
    async renderPage() {
      const clientDetails = await this.$store.dispatch(
        'client/fetchClientActiveDetail'
      )
      this.isActiveClient = clientDetails.client_active_flag
      await this.$store.dispatch('fetchSubscriptionDetails')
    },
    async updateSubscriptionDataOnScreen() {
      await this.$store.dispatch('fetchSubscriptionDetails')
      if (
        this.subscription.status === 'canceled' &&
        new Date() < new Date(this.subscription.current_period_end)
      ) {
        this.subscriptionStatus = 'active'
      } else {
        this.subscriptionStatus = this.subscription.status
      }
      if (this.subscription.current_period_start && this.subscription.current_period_end) {
        this.subscriptionPeriod = `${dateFormat(
          new Date(this.subscription.current_period_start),
          'dd mmm'
        )} - ${dateFormat(
          new Date(this.subscription.current_period_end),
          'dd mmm yyyy'
        )}`
      }
    },
    goToMarketPlace() {
      this.$router.push({ name: 'marketplace' })
    },
    async closeCreditCardModal(subscriptionDetail) {
      this.$bvModal.hide('addCreditCard-modal')
      await this.updateSubscriptionDataOnScreen()
      if (subscriptionDetail.status === 'active' && this.creditCardAction === 'addition') this.$refs.modalSuccess.open()
      else if (subscriptionDetail.status === 'active' && this.creditCardAction === 'updation') this.$refs.modalCardSuccess.open()
      else if (subscriptionDetail.status === 'validation pending') alert(this.$t('verifyCard'))
    },
    openCreditCardForm(action) {
      this.creditCardAction = action
      this.$bvModal.show('addCreditCard-modal')
    },
	onReady: function(instance) {
        instance.update(this.subscription.units_created);
      }
  }
}
</script>

<style lang="scss" scoped>
.unitProductsEmpty {
  display: block; //! none when FIRST unitProduct with this client_id is already found in db //
}
.activeClient {
  display: block; //! none when NO unitProduct with this client_id is found in db //
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 15px;
}

.iCountUp {
    // font-size: 12em;
    margin: 0;
    color: var(--primaryDark);
	text-align: center;
	padding-left: 30px;
}

.borderStyle {
   border: solid 1px var(--primaryDark) !important;
}

.iCountUp span {
    font-size: 65px;
    font-weight: 600;
}

.fullHeight {
  height: 100vh;
}
.login-btn {
  color: var(--primaryDark) !important;
  border: 1px solid var(--primaryDark);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover {
  background: var(--primaryDark);
  color: var(--bright) !important;
}

.graphTitle {
  font-size: 2em;
  color: var(--bg-superLight);
}
.cardTitle {
  font-size: 1.5em;
  color: var(--bg-superLight);
  font-weight: 600;
  padding-bottom: 10px;
}

.bgLightGray {
  background-color: var(--grey-light);
}
.metricsNo {
  font-size: 3.2em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsNo2 {
  font-size: 2em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}

.metricsContainer {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: 200px;
}
.metricsContainer2 {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-template-rows: 100px;
}

.metricsGraph {
  max-width: 380px;
}

.metricsDesc {
  letter-spacing: 1px;
  text-align: center !important;
}
.metricsUnit {
  font-size: 1.5em;
}
.input-group {
  max-width: 600px;
}
.form-control {
  height: auto;
}
.btn-secondary {
  padding: 0px 10px !important;
}
.btn-toolbar {
  position: absolute;
  right: 0;
}
.text-left {
  height: auto !important;
}
.neededData {
  text-align: left;
  width: 80%;
  margin: auto;
  font-size: 1.5em;
}
.neededData ul {
  list-style-type: none;
}
.neededData p {
  font-size: 1.5em;
  color: var(--primaryDark);
  font-weight: 600;
  margin-left: 25px;
}
.neededData span {
  margin-left: 5px;
  font-size: 1.2em;
}
.neededData .tick {
  color: var(--primaryDark);
  font-size: 25px;
}
.instructionsText {
  color: var(--primaryDark);
  font-size: 1.5em;
  padding: 0 10px;
  width: 85%;
  margin: auto;
  margin-top: 10px;
}
.instructionsText2 {
  color: var(--primaryDark);
  font-size: 1.5em;
  padding: 20px;
  width: 80%;
  margin: auto;
  margin-top: 50px;
}
.logo {
  font-family: 'Nasalization', Helvetica, Arial;
  margin-left: 4px;
}

// question tooltip css //@at-root
a,
a:visited {
  color: #fff;
  outline: none;
  text-decoration: none;
}

a:hover,
a:focus,
a:visited:hover {
  color: #fff;
  text-decoration: none;
}

.metricsName {
  position: relative;
  padding: 10px;
  color: var(--bg-superLight);
  font-size: 1em;
  background-color: var(--bright);
  border-radius: 15px;
  height: 90%;
  margin-right: 20px;
}

.metricsName2 {
  position: relative;
  padding: 10px;
  margin-right: 20px;
}

.metricsName h1,
.metricsName h2 {
  display: block;
  text-align: center;
  margin-top: 15px;
  font-size: 2.4rem;
  font-weight: 400;
  color: var(--bg-superLight);
}

.metricsName h2 {
  margin-top: 30px;
}

.help-tip {
  position: absolute;
  bottom: 10px;
  left: 70px;
  text-align: center;
  background-color: var(--grey-Dark);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  cursor: default;
  z-index: 3;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover {
  cursor: pointer;
  background-color: var(--primaryDark);
}

.help-tip:before {
  content: '?';
  font-weight: 700;
  color: #fff;
}

.help-tip p {
  visibility: hidden;
  opacity: 0;
  text-align: left;
  background-color: var(--grey-Dark);
  padding: 20px;
  width: 300px;
  margin-top: 3px;
  position: absolute;
  border-radius: 4px;
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: normal;
  transform: scale(0.7);
  transform-origin: 100% 0%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
.mr20 {
  margin-right: 20px;
}
.help-tip:hover p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}
.help-tip:active p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

.help-tip p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: var(--grey-Dark);
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  width: 100%;
  height: 40px;
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
}

.help-tip a {
  color: #fff;
  font-weight: 700;
}

.help-tip a:hover,
a:active .help-tip a:focus {
  color: #fff;
  text-decoration: underline;
}
// end of question tooltip//

.grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px 97vh 50px;
  grid-template-areas:
    'header'
    'main'
    'footer';
  height: 100vh;
}
.header {
  grid-area: header;
  background-color: rgb(224, 223, 223);
}
.main {
  grid-area: main;
  background-color: white;
}
.footer {
  grid-area: footer;
  background-color: var(--bg-superLight);
}
.feedback {
  color: var(--bg-superLight);
}
::v-deep .clientFeedbackModal {
  color: var(--bg-superLight) !important;
  text-align: left;
  overflow: auto;
}

.edit-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 200px;
  height: 30px;
}

.edit-btn2 {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 100px;
  height: 60px;
  font-size: 0.6em;
}

.add-card-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 2px;
  border: none;
  border-radius: 3.5px;
  width: auto;
  font-size: 1em;
}

.trial-end {
  color: #d1caca;
  font-style: bold;
  font-size: 0.8em;
  margin-top: 10px;
}
/* flexing header and footer*/
.header,
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  padding: 0 15px;
}


.circleTitle {
  font-size: 12px;
}
.circleNo {
  font-size: 17px;
}

.overview_card-info {
  text-align: left;
  margin-top: 10px;
}
.overview_card-info .circleTitle {
  text-align: center;
}
.overview_card-info p {
  text-align: left;
  margin: 0;
  padding: 0;
}
/* Layout for main content overview  and its cards*/
.main_overview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  // border-bottom: 1px solid lightgreen;
}
.overview_card {
  flex-basis: 250px;
  flex-grow: 1;
  margin: 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  /* background-color: seagreen; */
  height: 200px;
  border: 1px solid white;
  border-radius: 4px;
  color: white;
}
.overview_card2 {
  flex-basis: 250px;
  flex-grow: 1;
  margin: 10px 10px;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  height: 200px;
  border: 1px solid white;
  border-radius: 4px;
  color: white;
}
/* Layout for main-cards section // below main_overview */
.main_cards {
  margin: 10px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 500px 200px 200px;
  grid-template-areas:
    'card1'
    'card2'
    'card3'
    'card4'
    'card5'
    'card6';
  grid-gap: 10px;
}
.card {
  padding: 10px;
  border-radius: 4px;
}

.card:first-child {
  grid-area: card1;
}
.card:nth-child(2) {
  grid-area: card2;
}
.card:nth-child(3) {
  grid-area: card3;
}
.card:nth-child(4) {
  grid-area: card4;
}
.card:nth-child(5) {
  grid-area: card5;
}
.card:nth-child(6) {
  grid-area: card6;
}

.bg-blue {
  background: var(--bg-superLight);
  border: none;
}
.bg-gray {
  background: var(--gray);
  border: none;
}
.bg-alert {
  background: var(--primaryLight);
  border: none;
}

.header_search {
  margin-left: 24px;
  color: var(--bg-superLight);
}
.dropdown-item {
  color: var(--bg-superLight) !important;
  padding: 0;
  margin: 0px !important;
}

.about-img2 {
  display: inline-block;
  width: 80%;
  margin-top: 20px;
  max-width: 200px;
  text-align: center;
  vertical-align: top;
}
.about-img3 {
  display: inline-block;
  width: 100%;
  margin-top: 14px;
  max-width: 300px;
  text-align: center;
  vertical-align: top;
}
.img-wrapper {
  width: auto;
  position: relative;
}
.img-wrapper > img {
  position: relative;
}


/* responsive layout */
@media only screen and (min-width: 750px) {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 50px 1fr 50px;
    grid-template-areas:
      'header'
      'main'
      'footer';
    height: 100vh;
  }

  .main_cards {
    margin: 10px;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 200px 200px 200px;
    grid-template-areas:
      'card1 card2'
      'card1 card3'
      'card1 card4'
      'card5 card6';
    grid-gap: 10px;
  }
  .flexcard {
	position: relative;
	top: 20px;
	margin: 0 20px;
}
}
@media only screen and (min-width: 1000px) {
  .input-group {
    width: 75%;
  }
  .graphTitle {
    margin-top: 1em;
    margin-bottom: 0.5em;
  }
}

@media only screen and (min-width: 961px) {
  .flexcard {
	min-height: 900px !important;
}
}
@media only screen and (min-width: 1100px) {
  .flexcard {
	min-height: 800px !important;
}
}
@media only screen and (min-width: 1200px) {
  .flexcard {
	min-height: 750px !important;
}
}
@media only screen and (max-width: 1100px) {
.instructionsText {
  font-size: 1.3em;
}
.instructionsText2 {
  font-size: 1.3em;
}
  .header {
    padding: 0 5px;
  }
  .input-group {
    width: 75%;
  }
  .btn-secondary {
    padding: 1px 6px !important;
  }
  .mx-1 {
    margin-left: 0px !important;
    margin-top: 5px !important;
  }
}

@media only screen and (max-width: 750px) {	
	.metricsContainer {
  grid-template-columns: 1fr;
}
.help-tip {
	top: 20px;
	left: 15px;
  }
  .help-tip p {
    width: max-content;
    left: 0;
  }
  .help-tip p:before {
    left: 7px;
  }
}

@media only screen and (max-width: 500px) {
  .header {
    padding: 0 5px;
  }
  .footer {
    display: none;
  }
  .input-group {
    width: 85%;
  }
  .btn-secondary {
    padding: 1px 6px !important;
  }
  .mx-1 {
    margin-left: 0px !important;
    margin-top: 5px !important;
  }
  .help-tip {
    left: 23px;
    z-index: 0;
  }
  .help-tip p {
    width: 220px;
    left: 0;
  }
  .help-tip p:before {
    left: 10px;
  }
  .btn-toolbar {
    width: 95%;
  }
  .grid-container {
    grid-template-rows: 50px 250vh 50px;
  }
  .metricsGraph {
    max-width: 190px;
  }
  .metricsName {
    margin-right: 10px;
  }
  .metricsName h1 {
    font-size: 1.2rem;
  }
  .neededData {
    width: 90%;
  }
  .neededData ul {
    padding: 5px;
  }
  .instructionsText {
    padding: 0px;
	font-size: 1.35em;
  }
  .instructionsText2 {
  padding: 7px;
  width: 100%;
  font-size: 1.35em;
  margin-top: 30px;
}
  .trial-end {
  font-size: 0.7em;
}
.marketPlaceBtn {
	margin-top:30px;
}

}

@media only screen and (max-device-width: 900px) and (orientation: landscape) {
  .footer {
    display: none;
  }
}

@media only screen and (min-device-width: 960px) {
	.marketPlaceBtn {
	position: absolute;
	left: 50%;
	bottom: 28px;
	transform: translate(-50%, -50%);
	margin: 0 auto;
}
.stepByStepBtn {
	position: absolute;
	left: 50%;
	bottom: 0px;
	transform: translate(-50%, -50%);
	margin: 0 auto;
}
}


@media only screen and (max-device-width: 400px) and (orientation: portrait) {

  .neededData {
	font-size: 1.1em;
  }
  .neededData span {
	font-size: 0.9em;
  }
  .instructionsText {
	font-size: 1.2em;
  }
  .instructionsText2 {
	font-size: 1.2em;
  }
}
</style>
